import { getApp } from 'firebase/app';
import { connectFirestoreEmulator, getFirestore } from 'firebase/firestore';
import { connectStorageEmulator, getStorage } from 'firebase/storage';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import { logger } from './logger';
import { shouldUseEmulators as envShouldUseEmulators, logEnvironmentConfig } from './environmentConfig';

/**
 * Initialize Firebase emulators for local development
 * This connects the Firebase SDK to local emulators
 */
export const initializeEmulators = () => {
  try {
    const app = getApp();
    const db = getFirestore(app);
    const storage = getStorage(app);
    const functions = getFunctions(app);
    const auth = getAuth(app);

    // Connect to emulators
    connectFirestoreEmulator(db, 'localhost', 8080);
    connectStorageEmulator(storage, 'localhost', 9199);
    connectFunctionsEmulator(functions, 'localhost', 5001);
    connectAuthEmulator(auth, 'http://localhost:9099', { disableWarnings: false });

    logger.info('🔧 Firebase emulators connected successfully');

    // Log the current environment configuration
    logEnvironmentConfig();
  } catch (error) {
    logger.error('❌ Failed to connect to Firebase emulators:', error);
  }
};

/**
 * Checks if the app should use emulators
 * @returns boolean - true if app should use emulators
 */
export const shouldUseEmulators = (): boolean => {
  return envShouldUseEmulators();
};